import { Bell, BellOff } from 'lucide-react';
import { PUSH_HINTS, usePush } from '../lib/push';

/**
 * "Avisos no celular" (Mobile2): liga/desliga o push NESTE aparelho. Usado em
 * Configurações › Notificações e no topo de "Meus leads".
 */
export function PushCard({ compact = false }: { compact?: boolean }) {
  const { state, busy, error, enable, disable } = usePush();
  if (compact && (state === 'on' || state === 'loading' || state === 'server-off')) return null;
  const canToggle = state === 'on' || state === 'off';

  return (
    <div
      className={`flex items-start gap-3 rounded-xl border p-3 ${
        state === 'on' ? 'border-emerald-200 bg-emerald-50' : 'border-slate-200 bg-white'
      }`}
    >
      {state === 'on' ? (
        <Bell size={18} className="mt-0.5 shrink-0 text-emerald-600" />
      ) : (
        <BellOff size={18} className="mt-0.5 shrink-0 text-slate-400" />
      )}
      <div className="min-w-0 flex-1 space-y-2">
        <p className="text-[13px] font-semibold text-slate-900">Avisos no celular</p>
        <p className="text-xs text-slate-500">{PUSH_HINTS[state]}</p>
        {error && <p className="text-xs text-red-600">{error}</p>}
        {canToggle && (
          <button
            type="button"
            disabled={busy}
            onClick={() => void (state === 'on' ? disable() : enable())}
            className={`rounded-lg px-3 py-1.5 text-[13px] font-semibold disabled:opacity-50 ${
              state === 'on' ? 'border border-slate-300 bg-white text-slate-700' : 'text-white'
            }`}
            style={
              state === 'on'
                ? undefined
                : {
                    backgroundColor: 'var(--crm-primary)',
                    color: 'var(--crm-primary-foreground)',
                  }
            }
          >
            {busy
              ? 'Aguarde…'
              : state === 'on'
                ? 'Desativar neste aparelho'
                : 'Ativar neste aparelho'}
          </button>
        )}
      </div>
    </div>
  );
}
